/** @jsxImportSource @emotion/react */
import { VideoCameraChipGlyph } from '@/Client/Icons';

import { DEFAULT_KAI_NAV_GROUP_VIDEO_UNREAD_CHIP_STYLES, KaiNavGroupVideoUnreadChipStyles } from './kaiNavGroupVideoUnreadChipStyles';

/** Prototype grp-chip: unread walkthrough footage waiting for Kai. */
export const KaiNavGroupVideoUnreadChip = ({
  count,
  styles = DEFAULT_KAI_NAV_GROUP_VIDEO_UNREAD_CHIP_STYLES,
}: {
  count: number;
  styles?: KaiNavGroupVideoUnreadChipStyles;
}) => (
  <b css={styles.chip} className={'grp-chip'} title={'Footage not yet read by Kai'} data-testid={'kai-nav-group-video-unread-chip'}>
    <VideoCameraChipGlyph size={styles.iconSize} />
    {count} new
  </b>
);
